// import media files
import Avatar1 from 'assets/images/avatar/avatar-1.jpg';
import Avatar2 from 'assets/images/avatar/avatar-2.jpg';
import Avatar3 from 'assets/images/avatar/avatar-3.jpg';
import Avatar4 from 'assets/images/avatar/avatar-4.jpg';

export const ActivityData = [
	{
		id: 1,
		name: 'Jenny Wilson',
		image: Avatar1,
		topic: 'Just buy the courses”Build React Application Tutorial”',
		courses: 6,
		postedon: '2m ago',
		students: 50274,
		rating: 4.6,
		reviews: 12230,
		status: 'offline'
	},
	{
		id: 2,
		name: 'Dianna Smiley',
		image: Avatar2,
		topic: 'Comment on “Bootstrap Tutorial” Says “Hi,I m irene...',
		courses: 3,
		postedon: '1 hour ago',
		students: 26060,
		rating: 4.4,
		reviews: 11230,
		status: 'online'
	},
	{
		id: 3,
		name: 'Nia Sikhone',
		image: Avatar3,
		topic: 'Just share your article on Social Media..',
		courses: 12,
		postedon: '2 month ago',
		students: 8234,
		rating: 4.6,
		reviews: 10230,
		status: 'away'
	},
	{
		id: 4,
		name: 'Jacob Jones',
		image: Avatar4,
		topic: 'Just buy the courses "Build React Application Tutorial"',
		courses: 2,
		postedon: '2m ago',
		students: 8234,
		rating: 4.5,
		reviews: 2230,
		status: 'info'
	}
];

export default ActivityData;
